<template>
  <div style="background: linear-gradient(to bottom, #eee, #eee)">
    <div class="h5bg" v-if="xjhInfo">
      <div class="title">{{ xjhInfo.title_main }}校园招聘空中宣讲会</div>
      <div
        style="
          text-align: center;
          border-bottom: 1px solid #ccc;
          padding-bottom: 20px;
          padding-top: 10px;
        "
      >
        {{ xjhInfo.title_desc }}
      </div>
      <div class="desc">
        <div>
          <div>宣讲会开始时间：{{ xjhInfo.stime }}</div>
          <div>报名截止时间：{{ xjhInfo.etime }}</div>
          <div>宣讲会地点：{{ xjhInfo.xjh_address }}</div>
        </div>

        <div style="padding: 10px; text-align: center" v-if="!loading">
          <el-button
            icon="el-icon-check"
            style="margin-left: 10px"
            type="primary"
            @click="baoming()"
            >我要报名</el-button
          >
        </div>

        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="宣讲会详情" name="first"></el-tab-pane>
          <el-tab-pane label="企业简介" name="second"></el-tab-pane>
          <el-tab-pane label="职位列表" name="third"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName == 'first' && xjhInfo">
          <div v-html="xjhInfo.html_content"></div>

          <el-image
          v-for="(file, i) in xjhInfo.files"
          :key="i"
          class="fileitem"
          :src="file.src"
          fit="cover"
          :preview-src-list="[file.src]"
        ></el-image>


        </div>
        <div v-if="activeName == 'second' && xjhInfo">
          <div v-html="xjhInfo.enter_desc"></div>
        </div>
        <div v-if="activeName == 'third'">
          <table class="dttable" v-for="(job,idx) in xjhInfo.job_desc" :key="idx" style="margin-bottom:20px">
            <tr>
              <td class="tdheadersml">职位{{idx+1}}</td>
              <td>{{job.job_name}}</td>
            </tr>
            <tr v-if="job.job_type">
              <td class="tdheadersml">职位类型</td>
              <td>{{job.job_type}}</td>
            </tr>
            <tr v-if="job.job_num">
              <td class="tdheadersml">招聘人数</td>
              <td>{{job.job_num}}</td>
            </tr>
            <tr v-if="job.salary">
              <td class="tdheadersml">薪资待遇</td>
              <td>{{job.salary}}</td>
            </tr>
            <tr v-if="job.city_name">
              <td class="tdheadersml">工作城市</td>
              <td>{{job.city_name}}</td>
            </tr>
            <tr v-if="job.job_address">
              <td class="tdheadersml">工作地点</td>
              <td>{{job.job_address}}</td>
            </tr>
            <tr v-if="job.job_require">
              <td class="tdheadersml">职位要求</td>
              <td v-html="job.job_require"></td>
            </tr>
            <tr v-if="job.job_desc">
              <td class="tdheadersml">职位简介</td>
              <td v-html="job.job_desc"></td>
            </tr>

          </table>
        </div>

       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: 0,
      entInfo: null,
      xjhInfo: null,
      activeName: "first",
      schoolname: "",
      logo: "",
      loading: false,
      lurl: "",
    };
  },
  mounted() {
    this.lurl = window.location.href;
    document.title = "企业宣讲会";
    this.id = this.$route.params.id;
    this.getData();
  },
  methods: {
    getConfig() {
      this.$http
        .post("/api/sch_config_one", { ktype: "schoolname", pmid: window.pmid })
        .then((res) => {
          this.schoolname = res.data.kvalue;
        });
      this.$http
        .post("/api/sch_config_one", { ktype: "applogo", pmid: window.pmid })
        .then((res) => {
          this.logo = res.data.kvalue;
        });
    },
    getData() {
      this.$http.post("/api/h5_xjh_info", { id: this.id }).then((res2) => {
        res2.data.stime = res2.data.stime.substr(0, 16);
        res2.data.etime = res2.data.etime.substr(0, 16);
        try {
          res2.data.files = JSON.parse(res2.data.files);
          res2.data.job_desc = JSON.parse(res2.data.job_desc);
          for(let job of res2.data.job_desc){
            job.job_require = job.job_require.replace(/\n/g,"<br />")
            job.job_desc = job.job_desc.replace(/\n/g,"<br />")
          }
        } catch (error) {}
        this.xjhInfo = res2.data;
        window.pmid = res.data.pmid;
        if (!this.xjhInfo.qrcode) {
          this.$http
            .post("/api/h5_xjh_qrcode", { id: this.xjhInfo.id })
            .then((qrcode) => {
              this.xjhInfo.qrcode = qrcode.data.url;
            });
        }
      });
    },
    baoming() {
      if (!this.loading) {
        this.loading = true;
      } else {
        return;
      }
      let etime = new Date(this.xjhInfo.etime.replace(/-/g,'/')).getTime()
      if(etime<new Date().getTime()){
        this.$message.success("报名已截止！");
        return
      }
      this.$http
        .post("/api/h5_xjh_join", { xjh_id: this.xjhInfo.id, pmid: window.pmid })
        .then((res) => {
          this.$message.success("报名成功");
        });
    },
  },
};
</script>

<style scoped>
.h5bg {
  width: 95%;
  border: 10px solid #fff;
  margin: 0 auto;
  background: #fff;
  position: relative;
  padding: 10px;
  color: #373d5e;
}
.title {
  font-size: 24px;
  text-align: center;
  color: blue;
  padding-top: 10px;
}
.desc {
  line-height: 30px;
}

.fileitem {
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  display: inline-block;
  vertical-align: top;
  margin: 0 10px 10px 0;
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  color: #ccc;
  background-position: center;
  background-repeat: norepeat;
  background-size: cover;
}
</style>
